import services from '../services'
import * as types from './mutation-types'

export const GetTestimonials = ({ commit }, params) => (
  services.listTestimonials(params).then(res => {
    commit(types.SET_TESTIMONIALS, res.data)
  })
)

export const GetTestimonial = async ({ commit }, id) => {
  await services.getTestimonial(id).then(res => {
    commit(types.SET_TESTIMONIAL, res.data.data)
  })
}

export const SaveTestimonial = async ({ commit }, obj) => {
  await services.saveTestimonial(obj).then(res => {
    commit(types.SET_TESTIMONIAL, res.data.data)
    return res
  })
}

export const orderList = async ({ commit }, obj) => {
  await services.orderList(obj).then(res => {
    return res.data
  })
}

export const changeStatus = async ({ commit }, obj) => {
  await services.changeStatus(obj).then(res => {
    return res
  })
}

export const deleteTestimonial = async ({ commit }, obj) => {
  await services.deleteTestimonial(obj).then(res => {
    return res
  })
}
